import React, { PureComponent } from 'react'
import { Bar } from 'react-chartjs-2'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import styled from 'styled-components'
import max from 'lodash/max'

import { BlueBox, NoResults } from '../../../InfoBox'
import { Padding } from '../../..'
import { colors } from '../../../../constants'

const Header = styled.div`
    font-size: 15px;
    height: 50px;
`

const SubHeader = styled.span`
    color: ${colors.grey};
    margin-left: 10px;
`

const ChartContainer = styled.div`
    height: calc(100% - 60px);
    width: 100%;
`

class DeviceTypes extends PureComponent {
    static propTypes = {
        isEmpty: PropTypes.bool,
        loading: PropTypes.number,
        total: PropTypes.number,
        types: PropTypes.shape({}),
        t: PropTypes.func.isRequired,
    }

    static defaultProps = {
        isEmpty: true,
        loading: null,
        total: 0,
        types: [],
    }

    constructor(props) {
        super(props)

        this.primaryColor = colors.bluelight
        this.secondaryColor = colors.white
    }

    /**
     * Gets values of the chart
     */
    get data() {
        const { types } = this.props
        const { labels } = this
        return labels.map((label) => types[label])
    }

    /**
     * Gets lower model labels
     */
    get labels() {
        const { types } = this.props
        return Object.keys(types)
            .filter((type) => !!types[type])
            .sort((t1, t2) => types[t1] - types[t2])
    }

    /**
     * Gets length of the data array
     */
    get length() {
        const { data } = this
        return data.length
    }

    render() {
        const { isEmpty, loading, total: totalDevices, t } = this.props

        return (
            <BlueBox loading={loading} noResults={isEmpty}>
                <Header>
                    <Padding>
                        {t('Device Types')}
                        <SubHeader>{`(${totalDevices} devices)`}</SubHeader>
                    </Padding>
                </Header>
                <ChartContainer>
                    <Padding bottom fullHeight>
                        {isEmpty && <NoResults />}
                        {!isEmpty && (
                            <Bar
                                data={{
                                    labels: this.labels,
                                    datasets: [
                                        {
                                            backgroundColor: this.primaryColor,
                                            borderWidth: 0,
                                            hoverBackgroundColor: colors.white,
                                            data: this.data,
                                            pointRadius: 0,
                                            label: 'Devices',
                                        },
                                    ],
                                }}
                                options={{
                                    bezierCurve: false,
                                    datasetFill: false,
                                    legend: {
                                        display: false,
                                    },
                                    maintainAspectRatio: false,
                                    plugins: {
                                        datalabels: {
                                            align: (context) => {
                                                // If value is above the top 90%, the label will be painted
                                                // inside the column
                                                const { dataIndex } = context
                                                const value = context.dataset.data[dataIndex]
                                                const maxValue = max(this.data)
                                                return value < maxValue * 0.9 ? 'end' : 'start'
                                            },
                                            anchor: 'end',
                                            color: colors.white,
                                            offset: 5,
                                        },
                                    },
                                    scales: {
                                        xAxes: [
                                            {
                                                gridLines: {
                                                    color: 'transparent',
                                                },
                                                ticks: {
                                                    fontColor: colors.white,
                                                },
                                            },
                                        ],
                                        yAxes: [
                                            {
                                                gridLines: {
                                                    color: colors.bluedark,
                                                },
                                                ticks: {
                                                    fontColor: colors.white,
                                                },
                                            },
                                        ],
                                    },
                                }}
                            />
                        )}
                    </Padding>
                </ChartContainer>
            </BlueBox>
        )
    }
}

export default withTranslation()(DeviceTypes)
